/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.19",
    versionName: "0.2.0-nightly.2026.4.19",
    versionChannel: "nightly",
    buildDate: "2026-04-19T00:15:07.256Z",
    commitHash: "9aeb23c9603c1d7c75b36c8e56a724cf5b74c585",
};
